import styled from 'styled-components';

export const ReuseableFieldNameWrapper = styled.div`
  margin-bottom: 20px;
  margin-top: 5px;
`;